module.exports = __webpack_public_path__ + "static/media/DBA.569ad3b9.svg";